let videoLinks = [];
const video = document.getElementById("video");


// Password
const password = document.getElementById("secret__password");
const render = document.getElementById("render__container");
const template = document.getElementById("html_to_render");
const submitButton = document.getElementById("password__submit");
const errorMessage = document.getElementById("error__message");

const unlocked = localStorage.getItem(pageHandle);

if (unlocked) {
  render.innerHTML = template.innerHTML;
  videoLinks = document.querySelectorAll(".video__link");
  initVideos();
}

password.addEventListener("keypress", (e) => {
  if (e.key !== "Enter") return;

  if (password.value === pswrd) {
    localStorage.setItem(pageHandle, "true");
    render.innerHTML = template.innerHTML;
    videoLinks = document.querySelectorAll(".video__link");
    console.log(videoLinks);
    initVideos();
  }
});

submitButton.addEventListener("click", () => {
  if(password.value !== pswrd) return errorMessage.classList.remove("hidden");

  if (password.value === pswrd) {
    localStorage.setItem(pageHandle, "true");
    render.innerHTML = template.innerHTML;
    videoLinks = document.querySelectorAll(".video__link");
    console.log(videoLinks);
    initVideos();
  }
});

// Modal
const modalContainer = document.querySelector(".video__modal");
const modalClose = document.querySelector(".modal__close");
// Close Modal
modalClose.addEventListener("click", () => {
  modalContainer.classList.remove("video__modal--active")
  video.pause()
}
);

function initModal() {
  modalContainer.classList.toggle("video__modal--active");
  if (!video.paused) video.pause();
}

function initVideos() {
  if (!Hls.isSupported()) return;
  videoLinks.forEach((link) => {
    link.addEventListener("click", () => listenToLink(link));
  });
}

// Attach Sources to #video
function listenToLink(element) {
  if (Hls.isSupported()) {
    const hls = new Hls();
    hls.attachMedia(video);
    hls.on(Hls.Events.MEDIA_ATTACHED, () => {
      hls.loadSource(`${element.dataset.url}`);
    });
    initModal();
  } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
    video.src = `${element.dataset.url}`;
    initModal();
  }
}
